import { message } from "antd";
import Router from "../..";
import { handleApiError } from "./indexApi";

const BASE_URL = process.env.REACT_APP_API_URL_PRO;

export const paymentApi = {
  createPayment: async (payload) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/payment/wait/accept`,
        payload,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (data?.error?.text) {
        message.error(data.error.text);
        return;
      }
      if (data?.result) return data.result;
    } catch (err) {
      handleApiError(err, "결제 전 서버 저장에 실패했습니다.");
      return;
    }
  },

  confirmPayment: async (payload) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/payment/accept`,
        payload,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data?.error) {
        return data;
      }
      if (data?.result) return data.result;
    } catch (err) {
      handleApiError(err, "결제는 완료되었지만 결제 승인 처리가 실패했습니다.");
      return false;
    }
  },

  // 브랜드의 나의 결제 내역
  getBrandPaymentHistory: async (campaign_id, status, page) => {
    try {
      const { data } = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/payment/get/brand/order/list`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
          params: { campaign_id, status, page },
        }
      );
      if (data?.error?.text) {
        return null;
      }
      if (data) return data;
    } catch (err) {
      handleApiError(err, "나의 결제 내역 조회에 실패했습니다.");
      return null;
    }
  },

  // 브랜드의 나의 결제 내역 상세
  getBrandPaymentHistoryDetail: async (pay_report_id, status) => {
    try {
      const { data } = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/payment/get/order/detail`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
          params: { pay_report_id, status },
        }
      );
      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data?.result) return data.result;
    } catch (err) {
      handleApiError(err, "나의 결제 내역 상세 조회에 실패했습니다.");
    }
  },

  // 브랜드의 결제 환불
  refundBrandPayment: async (pay_report_id, refund_reason) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/payment/cancel`,
        { pay_report_id, refund_reason },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      message.success("환불 신청이 완료되었습니다.");
      return true;
    } catch (err) {
      handleApiError(err, "환불 요청이 실패되었습니다.");
      return false;
    }
  },

  // 크리에이터의 정산 내역
  getInfluencerPaymentHistory: async (campaign_id, status) => {
    try {
      const { data } = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/payment/get/influencer/list`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
          params: { campaign_id, status },
        }
      );
      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data) return data;
    } catch (err) {
      handleApiError(err, "정산 내역 조회에 실패했습니다.");
    }
  },

  // 에이전시의 정산 내역
  getAgencyPaymentHistory: async (campaign_id, status) => {
    try {
      const { data } = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/payment/get/agency/list`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
          params: { campaign_id, status },
        }
      );
      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data) return data;
    } catch (err) {
      handleApiError(err, "정산 내역 조회에 실패했습니다.");
    }
  },

  // 브랜드의 나의 캠페인의 전체 결제 내역 (정산 엑셀 파일 만들기 용)
  getBrandPaidList: async (campaign_id) => {
    try {
      const { data } = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/payment/get/brand/paid/list`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
          params: { campaign_id },
        }
      );
      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data) return data;
    } catch (err) {
      handleApiError(err, "해당 캠페인의 정산 내역 조회에 실패했습니다.");
    }
  },

  // 임시 계좌 입금 결제 플로우
  requestBankTransferPayment: async (payload) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/payment/bank-transfer/wait/accept`,
        payload,
        { headers: { authorization: localStorage.getItem("authorization") } }
      );

      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data?.result) return data.result;
    } catch (err) {
      handleApiError(err, "결제 요청이 실패되었습니다.");
      return false;
    }
  },

  // 계좌이체 결제 환불
  refundBankTransferPayment: async (id, refund_reason) => {
    try {
      const { data } = await Router.CustomAxios.post(
        `${BASE_URL}/surfingcre/api/v1/payment/bank-transfer/cancel`,
        { id, refund_reason },
        { headers: { authorization: localStorage.getItem("authorization") } }
      );
      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      message.success("결제 취소가 완료되었습니다.");
      return true;
    } catch (err) {
      handleApiError(err, "결제 취소 요청이 실패되었습니다.");
      return false;
    }
  },

  // 브랜드의 환불 거절 상세보기
  getRejectedRefund: async (pay_report_id) => {
    try {
      const { data } = await Router.CustomAxios.get(
        `${BASE_URL}/surfingcre/api/v1/payment/get/rejected/refund`,
        {
          headers: { authorization: localStorage.getItem("authorization") },
          params: { pay_report_id },
        }
      );
      if (data?.error?.text) {
        message.error(data.error.text);
        return false;
      }
      if (data) return data;
    } catch (err) {
      handleApiError(err, "해당 결제 건의 내용 조회에 실패했습니다.");
    }
  },
};
